// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"668cc2ce","264":"91dd8ca7","418":"040e8446","453":"e42d539d","480":"c2c0d4c0","638":"184bfcc6"}[chunkId] + ".chunk.js";
};